/**
 * NERO LIVING - Custom Product Options
 * Performance optimised: MutationObserver, no polling, no setTimeout chains
 */

(function() {
  'use strict';

  const NeroOptions = {

    init() {
      this.waitForGlobo();
    },

    waitForGlobo() {
      // Check if already loaded
      const globoApp = document.querySelector('.gpo-app');
      const elements = document.querySelectorAll('.gpo-element');

      if (globoApp && elements.length > 0) {
        requestAnimationFrame(() => this.buildCustomUI());
        return;
      }

      // Use MutationObserver instead of setInterval polling
      const observer = new MutationObserver((mutations, obs) => {
        const globoApp = document.querySelector('.gpo-app');
        const elements = document.querySelectorAll('.gpo-element');

        if (globoApp && elements.length > 0) {
          obs.disconnect();
          requestAnimationFrame(() => this.buildCustomUI());
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      // Timeout safety
      setTimeout(() => observer.disconnect(), 10000);
    },

    buildCustomUI() {
      if (document.querySelector('.nero-options')) return;

      const globoApp = document.querySelector('.gpo-app');
      if (!globoApp) return;

      const elements = document.querySelectorAll('.gpo-element');
      if (elements.length === 0) return;

      // Create price display
      const title = document.querySelector('.nero-product__title');
      const basePrice = document.querySelector('.nero-product__price-value');

      if (title && !document.querySelector('.nero-custom-price-display')) {
        const priceDiv = document.createElement('div');
        priceDiv.className = 'nero-custom-price-display';
        priceDiv.textContent = basePrice ? basePrice.textContent : '';
        title.parentNode.insertBefore(priceDiv, title.nextSibling);
      }

      // Create options container
      const container = document.createElement('div');
      container.className = 'nero-options';

      elements.forEach((el, index) => {
        const option = this.parseOption(el, index);
        if (option) {
          container.appendChild(this.createSelect(option));
        }
      });

      // Insert container INSIDE the form, before the Add to Cart button
      // This keeps the button inside the form so submit works correctly with Globo
      const atcButton = document.querySelector('.nero-product__add-to-cart');

      if (atcButton && atcButton.parentNode) {
        // Insert our options container before the button, but still inside the form
        atcButton.parentNode.insertBefore(container, atcButton);

        // Add selections text before button
        const selectionsDiv = document.createElement('div');
        selectionsDiv.className = 'nero-selections-text';
        atcButton.parentNode.insertBefore(selectionsDiv, atcButton);
      } else {
        // Fallback: insert before globo
        globoApp.parentNode.insertBefore(container, globoApp);
      }

      this.updatePrice();
      this.watchPriceChanges();
    },

    parseOption(element, index) {
      const labelEl = element.querySelector('.gpo-label .label-content, .gpo-label');
      if (!labelEl) return null;

      let label = labelEl.textContent.trim();
      label = label.replace(/\s*\*\s*$/, '');
      label = label.replace(/\s*add-ons?\s*/gi, ' ').trim();

      const dropdown = element.querySelector('.gpo-dropdown');
      if (!dropdown) return null;

      const items = dropdown.querySelectorAll('.dropdown-item');
      const options = [];

      items.forEach((item, i) => {
        const valueEl = item.querySelector('.dropdown-item__value, label, span');
        const priceEl = item.querySelector('.option-addon, .gpo-price-addon, .price-addon, [class*="addon"], [class*="price"]');
        const imgEl = item.querySelector('.swatch-image, .dropdown-item__thumbnail img');

        let text = valueEl ? valueEl.textContent.trim() : '';
        let price = priceEl ? priceEl.textContent.trim() : '';
        let image = imgEl ? imgEl.src : '';

        if (!price && item.textContent.includes('£')) {
          const match = item.textContent.match(/(\+?\s*£[\d,.]+)/);
          if (match) price = match[1].trim();
        }

        if (text) {
          text = text.replace(/\s*\(\+?\s*£[\d,.]+\)\s*/g, '').trim();
          text = text.replace(/\s*\+\s*£[\d,.]+\s*/g, '').trim();
        }

        if (text || image) {
          options.push({ index: i, text, price, image, element: item });
        }
      });

      return {
        index,
        label,
        options,
        element,
        dropdown,
        hasImages: options.some(o => o.image)
      };
    },

    createSelect(option) {
      const wrapper = document.createElement('div');
      wrapper.className = 'nero-option';
      wrapper.dataset.index = option.index;

      if (option.hasImages) {
        wrapper.appendChild(this.createSwatchDropdown(option));
      } else {
        const label = document.createElement('label');
        label.className = 'nero-option__label';
        label.textContent = option.label;
        wrapper.appendChild(label);

        const select = document.createElement('select');
        select.className = 'nero-option__select';

        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Select ' + option.label.toLowerCase() + '...';
        placeholder.disabled = true;
        placeholder.selected = true;
        select.appendChild(placeholder);

        option.options.forEach((opt) => {
          const optionEl = document.createElement('option');
          optionEl.value = opt.index;
          optionEl.textContent = opt.text + (opt.price ? ' ' + opt.price : '');
          select.appendChild(optionEl);
        });

        select.addEventListener('change', (e) => this.selectOption(option, e.target.value));
        wrapper.appendChild(select);
      }

      return wrapper;
    },

    createSwatchDropdown(option) {
      const dropdown = document.createElement('div');
      dropdown.className = 'nero-swatch-dropdown';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'nero-swatch-dropdown__button';

      const previewSwatches = document.createElement('div');
      previewSwatches.className = 'nero-swatch-dropdown__previews';
      const previewCount = Math.min(4, option.options.length);
      for (let i = 0; i < previewCount; i++) {
        if (option.options[i].image) {
          const mini = document.createElement('img');
          mini.src = option.options[i].image;
          mini.className = 'nero-swatch-dropdown__mini';
          previewSwatches.appendChild(mini);
        }
      }
      button.appendChild(previewSwatches);

      const labelText = document.createElement('span');
      labelText.className = 'nero-swatch-dropdown__label';
      labelText.innerHTML = '<strong>' + option.label.toUpperCase() + ':</strong> SELECT...';
      button.appendChild(labelText);

      const arrow = document.createElement('span');
      arrow.className = 'nero-swatch-dropdown__arrow';
      arrow.textContent = '▼';
      button.appendChild(arrow);

      const panel = document.createElement('div');
      panel.className = 'nero-swatch-dropdown__panel';

      const disclaimer = document.createElement('div');
      disclaimer.className = 'nero-swatch-dropdown__disclaimer';
      disclaimer.innerHTML = '*Preview only<br><a href="/products/free-swatch">order free swatches for accurate fabrics</a>';
      panel.appendChild(disclaimer);

      const fabricGroups = [
        { name: 'BOUCLE INSPIRED', prefixes: ['BOUCLE', 'MANHATTAN', 'VIENNA'] },
        { name: 'LINEN INSPIRED', prefixes: ['LINEN'] },
        { name: 'VELVET INSPIRED', prefixes: ['MISO', 'NAPOLI', 'SHARON', 'VELVET'] },
        { name: 'PREMIUM', prefixes: [], isPremium: true }
      ];

      // Find the price of premium swatches dynamically from Globo data
      const getPremiumPrice = () => {
        const premiumPrefixes = ['BOUCLE', 'MANHATTAN', 'VIENNA', 'LINEN', 'MISO', 'NAPOLI', 'SHARON', 'VELVET'];
        for (const opt of option.options) {
          const upper = (opt.text || '').toUpperCase();
          const isPremium = !premiumPrefixes.some(p => upper.startsWith(p));
          if (isPremium && opt.price) {
            const match = opt.price.match(/£([\d,]+)/);
            if (match) return '+£' + match[1];
          }
        }
        return '';
      };

      const premiumPriceLabel = getPremiumPrice();

      const getGroup = (name) => {
        const upper = (name || '').toUpperCase();
        for (const group of fabricGroups) {
          if (group.isPremium) continue;
          if (group.prefixes.some(p => upper.startsWith(p))) return group.name;
        }
        return 'PREMIUM' + (premiumPriceLabel ? ' (' + premiumPriceLabel + ')' : '');
      };

      let currentGroup = null;

      option.options.forEach((opt) => {
        const group = getGroup(opt.text);

        if (group && group !== currentGroup) {
          currentGroup = group;
          const header = document.createElement('div');
          header.className = 'nero-swatch-dropdown__header';
          if (group.startsWith('PREMIUM')) {
            header.innerHTML = group + ' <span class="nero-premium-note">No preview — <a href="/products/free-swatch">order free swatch</a></span>';
          } else {
            header.textContent = group;
          }
          panel.appendChild(header);
        }

        const swatch = document.createElement('button');
        swatch.type = 'button';
        swatch.className = 'nero-swatch';
        swatch.dataset.index = opt.index;

        if (opt.image) {
          const img = document.createElement('img');
          img.src = opt.image;
          img.alt = opt.text || '';
          swatch.appendChild(img);
        }

        if (opt.price) {
          const badge = document.createElement('span');
          badge.className = 'nero-swatch__price';
          const priceMatch = opt.price.match(/£([\d,]+)/);
          badge.textContent = priceMatch ? '+£' + priceMatch[1] : opt.price;
          swatch.appendChild(badge);
        }

        // Preload fabric image on hover
        swatch.addEventListener('mouseenter', () => {
          if (opt.text && typeof window.neroPreloadImage === 'function') {
            const fabricName = opt.text.toUpperCase().trim().replace(/\s+/g, ' ');
            for (let i = 0; i < window.neroProductImages.length; i++) {
              const img = window.neroProductImages[i];
              const alt = (img.alt || '').toUpperCase();
              if (alt.indexOf(fabricName) !== -1) {
                window.neroPreloadImage(img.url);
                break;
              }
            }
          }
        });

        swatch.addEventListener('click', () => {
          panel.querySelectorAll('.nero-swatch').forEach(s => s.classList.remove('is-selected'));
          swatch.classList.add('is-selected');

          const labelEl = button.querySelector('.nero-swatch-dropdown__label');
          if (labelEl) {
            let labelContent = '<strong>' + option.label.toUpperCase() + ':</strong> ' + (opt.text || 'Selected').toUpperCase();
            if (opt.price) labelContent += ' ' + opt.price;
            labelEl.innerHTML = labelContent;
          }

          dropdown.dataset.selectedPrice = opt.price || '';

          if (opt.text && typeof window.neroChangeFabricImage === 'function') {
            window.neroChangeFabricImage(opt.text);
          }

          dropdown.classList.remove('is-open');
          this.clickGloboItem(opt.element);
        });

        panel.appendChild(swatch);
      });

      button.addEventListener('click', () => {
        document.querySelectorAll('.nero-swatch-dropdown.is-open').forEach(d => {
          if (d !== dropdown) d.classList.remove('is-open');
        });
        dropdown.classList.toggle('is-open');
      });

      document.addEventListener('click', (e) => {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove('is-open');
        }
      });

      dropdown.appendChild(button);
      dropdown.appendChild(panel);

      return dropdown;
    },

    selectOption(option, itemIndex) {
      const item = option.options.find(o => o.index == itemIndex);
      if (item && item.element) {
        this.clickGloboItem(item.element);
      }
    },

    clickGloboItem(item) {
      const input = item.querySelector('input');
      if (input) {
        input.click();
      } else {
        item.click();
      }
      this.debouncedUpdatePrice();
    },

    updatePrice() {
      const customPrice = document.querySelector('.nero-custom-price-display');
      if (!customPrice) return;

      const basePriceEl = document.querySelector('.nero-product__price-value');
      let basePrice = 0;
      if (basePriceEl) {
        const match = basePriceEl.textContent.match(/£([\d,.]+)/);
        if (match) basePrice = parseFloat(match[1].replace(',', ''));
      }

      let addOnPrice = 0;

      document.querySelectorAll('.nero-option__select').forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.textContent) {
          const match = selectedOption.textContent.match(/\+\s*£([\d,.]+)/);
          if (match) addOnPrice += parseFloat(match[1].replace(',', ''));
        }
      });

      document.querySelectorAll('.nero-swatch-dropdown').forEach(dropdown => {
        const selectedPrice = dropdown.dataset.selectedPrice || '';
        if (selectedPrice) {
          const match = selectedPrice.match(/£([\d,.]+)/);
          if (match) addOnPrice += parseFloat(match[1].replace(',', ''));
        }
      });

      const total = basePrice + addOnPrice;
      if (total > 0) {
        customPrice.textContent = '£' + total.toFixed(2);
      }

      const selectionsDisplay = document.querySelector('.nero-selections-text');
      if (selectionsDisplay && addOnPrice > 0) {
        selectionsDisplay.textContent = 'Selections will add £' + addOnPrice.toFixed(2) + ' to the price';
      } else if (selectionsDisplay) {
        selectionsDisplay.textContent = '';
      }
    },

    debouncedUpdatePrice: (function() {
      let timeout;
      return function() {
        clearTimeout(timeout);
        timeout = setTimeout(() => this.updatePrice(), 100);
      };
    })(),

    watchPriceChanges() {
      const globoApp = document.querySelector('.gpo-app');
      if (!globoApp) return;

      let timeout;
      const observer = new MutationObserver(() => {
        clearTimeout(timeout);
        timeout = setTimeout(() => this.updatePrice(), 150);
      });

      observer.observe(globoApp, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => NeroOptions.init());
  } else {
    NeroOptions.init();
  }
})();
